export default {
  namespaced: true,
  vxg_camera: {
    id_vxg: "ID VXG",
    name: "Nombre",
    rec_mode: "Modo Grabación",
    live_stream: "Transmisión en Vivo",
    recording_stream: "Transmisión Video Grabado",
    access_token_watch: "Token de Acceso a Video",
    access_token_all: "Token de Acceso a Todo",
    streaming: "Streaming",
    timezone: "Zona Horaria",
    update_from_vxg: "Actualizar Camaras desde API",
    select_multiple: "Seleccionar Múltiple",
    delete_vxg_sbo: "Eliminar VaaS y SBO",
    delete_sbo: "Eliminar en SBO",
    removed: "Elimando",
    removed_cameras: "Eliminando camaras",
    rec_limit: "Días de grabación",
    location: "Ubicación" || "Ubicaciones",
    stream: "Transmisión",
    recording: "Grabación",
    main_transmission: "Transmisión de video en vivo",
    live_broadcast: "Transmisión de video grabado",
    live_transmission: "Transmisión en vivo",
    transmission: "Configuración de transmisión",
    video_encoder: "Codificador de video",
    vbr_quality: "Calidad VBR",
    vbr: "VBR",
    events_enabled: "Eventos Habilitados",
    register_type: "Tipo de registro",
    bitrate: "Tasa de bits",
    update_stream: "Actualizar configuración de transmisión",
    ip: "IP",
    fps: "FPS de transmisión",
    resolution_stream: "Resolución de transmisión",
    format_stream: "Formato de transmisión",
    camera_not_connected: "La cámara no está conectada en este momento.",
  },
};
